/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from "@theme-ui/mdx"
import { Grid } from "@theme-ui/components"
import PropTypes from "prop-types"
import { rem } from "@src/theme"
import BannerBlock from "@components/BannerBlock"

const CalloutTextBlocks = ({ blocks, heading }) => {
  return heading ? (
    <BannerBlock title={heading} noMaxWidth>
      <Grid columns={[1, 1, 3]} gap={2}>
        {blocks.slice(0, 3).map(({ heading, body }) => (
          <div
            sx={{
              mx: "auto",
              textAlign: "center",
              px: [0, 2, null, 0],
              maxWidth: [rem(325), rem(400), "auto"],
              mb: [rem(70), null, 0],
            }}
            key={heading}
          >
            <Themed.h3 sx={{ mt: 0, mb: rem(30) }}>{heading}</Themed.h3>
            <p
              sx={{
                mb: 0,
              }}
            >
              {body}
            </p>
          </div>
        ))}
      </Grid>
    </BannerBlock>
  ) : (
    <Grid columns={[1, 1, 3]} gap={2}>
      {blocks.slice(0, 3).map(({ heading, body }) => (
        <div
          sx={{
            mx: "auto",
            textAlign: "center",
            px: [0, 2, null, 0],
            maxWidth: [rem(325), rem(400), "auto"],
            mb: [rem(70), null, 0],
          }}
          key={heading}
        >
          <Themed.h3 sx={{ mt: 0, mb: rem(30) }}>
            {/* check for new line character */}
            {heading.split("/n").map((part, index) => (
              <span key={index} sx={{ display: ["inline", "inline", "block"] }}>
                {part}
              </span>
            ))}
          </Themed.h3>
          <p
            sx={{
              mb: 0,
            }}
          >
            {body}
          </p>
        </div>
      ))}
    </Grid>
  )
}

export default CalloutTextBlocks

CalloutTextBlocks.propTypes = {
  heading: PropTypes.string,
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      body: PropTypes.string,
      heading: PropTypes.string,
    })
  ),
}
